import styled from 'styled-components';

export const ErrorMessage = styled.p`
  color: ${(props): string => props.theme.palette.danger.main};
  font-weight: bold;
  margin-bottom: 0;
`;
